import { IFacet } from '@ucheba/utils/types/search'
import { professionsSearchSlice } from './index'

export interface IProfessionsSearchState {
  [key: string]: ReturnType<typeof professionsSearchSlice.reducer>
}

export interface IProfessionsSearch {
  total: number
  items: IItemOfProfessionsBySearch[]
  facets: {
    tags: IProfFacetsTag[]
    institutionTypes: IProfFacetsInstitutionTypes[]
    compilations: IProfFacetsCompilations[]
  }
  seo: {
    h1: string
    description: string
  }
}

export interface IProfessionsSearchByFriendlyURL {
  result: IProfessionsSearch
  criteria: {
    offset: number
    limit: number
    query: string
    tagIds: number[]
    institutionTypes: number[]
    compilationIds: number[]
  }
  canIndex: true
}

export interface IProfFacetsCompilations {
  value: number
  name: string
  count: number | null
  iconUrl: string | null
  slug?: string | null
}

export interface IProfFacetsInstitutionTypes {
  value: number
  name: string
  count: number | null
}

export interface IProfFacetsTag extends ITagInfo {
  items: ITagInfo[] | null
}

interface ITagInfo {
  value: number
  name: string
  count: number | null
  nameDative: string | null
  nameGenitive: string | null
  nameAdjective: string | null
  nameProfPlural: string | null
  iconUrl: string | null
  color: string | null
  slug: string | null
}

export interface IItemOfProfessionsBySearch {
  shortDescription: string | null
  stats: IStats | null
  tagIds: number[] | null
  specialityIds: number[] | null
  id: number
  name: string
}

interface IStats {
  universitiesCount: number
  collegesCount: number
  coursesCount: number
  specialitiesCount: number
}

export enum EProfessionsSearchFacets {
  institutionTypes = 'institutionTypes',
  compilations = 'compilations',
  tags = 'tags',
}

export enum EProfessionsSearchDataKeys {
  institutionTypes = 'institutionTypes',
  compilationIds = 'compilationIds',
  examSubjectIds = 'examSubjectIds',
  tagIds = 'tagIds',
  query = 'query',
}

export interface IProfessionsSearchFacets {
  [EProfessionsSearchFacets.institutionTypes]: IFacet[]
  [EProfessionsSearchFacets.tags]: IFacet[]
  [EProfessionsSearchFacets.compilations]: IFacet[]
}
